import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { Box, Button, Typography } from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import { FunctionComponent, useState } from 'react';
import { useAppTranslate } from '../../../../core/hooks';
import { ChartSettings } from '../../../chart-settings/model';
import { buildSeriesData, SlaMetricsMeasurementViewModel, SlaMonitoredClassOfServiceViewModel } from '../../model';
import { SlaStatisticsTableChartDialog } from '../SlaStatisticsTableChartDialog/SlaStatisticsTableChartDialog';
import { useTimeSeriesStatisticsHighchartsOptions } from '../../../timeseries-statistics/hooks/TimeSeriesStatistics.hook';

interface Props {
  chartData: SlaMetricsMeasurementViewModel;
  classOfService: SlaMonitoredClassOfServiceViewModel;
  metric: 'jitter' | 'delay' | 'lossRatio';
  unit: 'millisecond' | 'percent';
  chartSettings: ChartSettings;
  customerId: number;
}

export const SlaStatisticsTableChart: FunctionComponent<Props> = (
  { classOfService, chartData, metric, unit, chartSettings, customerId },
) => {
  const translate = useAppTranslate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const seriesName = translate('tableHeaders.' + metric);
  const unitTranslated = translate('units.' + unit);
  const chartTitle = `${translate('tableHeaders.' + metric)} [${unitTranslated}]`;
  const seriesData = buildSeriesData(chartData, metric);
  const highchartsOptions = useTimeSeriesStatisticsHighchartsOptions(
    chartSettings,
    unitTranslated,
    [{ seriesData, seriesName }]);

  return <Box role={'presentation'} sx={{ background: '#fff', borderRadius: '1rem', padding: 1 }}>
    <Box sx={{
      display: 'flex',
      flexDirection: {
        xs: 'column',
        md: 'row',
      },
      justifyContent: 'space-between',
      alignItems: 'center',
      p: 1,
    }}>
      <Typography>{chartTitle}</Typography>
      <Button
        variant={'slim'}
        size={'small'}
        endIcon={<FullscreenIcon />}
        onClick={() => setDialogOpen(true)}
      >{translate('charts.fullview')}</Button>
    </Box>
    <HighchartsReact
      highcharts={Highcharts}
      options={highchartsOptions}
    />
    <SlaStatisticsTableChartDialog
      initialChartSettings={{ resolution: chartSettings.resolution, timespan: chartSettings.timespan }}
      initialChartData={ chartData }
      classOfService={ classOfService }
      metric={ metric }
      unit={ unit }
      open={ dialogOpen }
      onClose={ () => setDialogOpen(false) }
      customerId={ customerId }
    />
  </Box>;
};